import { render, staticRenderFns } from "./KT-ProgressStatus.vue?vue&type=template&id=023972c4&scoped=true&lang=pug&"
import script from "./KT-ProgressStatus.vue?vue&type=script&lang=js&"
export * from "./KT-ProgressStatus.vue?vue&type=script&lang=js&"
import style0 from "./KT-ProgressStatus.vue?vue&type=style&index=0&id=023972c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023972c4",
  null
  
)

export default component.exports